// The app shell marks its inset with this attribute, and each page primitive
// declares how it looks inside one: flush against the sidebar, no rounding, no
// outer border, only the divider on the edge that meets it. Attribute variants
// outrank a caller's own classes, so a page cannot bring the floating chrome
// back, and the primitives stay server-safe: no context, no client boundary.
export const PAGE_SHELL_ATTR = "data-page-shell";

// A page that scrolls inside itself says so on its root, and the shell pins
// its inset to the viewport for it. Pages that grow with their content say
// nothing and scroll the document.
export const PAGE_BOUNDED_ATTR = "data-page-bounded";

export const SHELL_FLUSH_CHROME =
  "[[data-page-shell]_&]:rounded-none [[data-page-shell]_&]:border-y-0 [[data-page-shell]_&]:border-l [[data-page-shell]_&]:border-r-0 [[data-page-shell]_&]:border-l-surface-quatenary";
export const SHELL_CARD_BOUNDED = "[[data-page-shell]_&]:h-svh";
export const SHELL_CARD_UNBOUNDED = "[[data-page-shell]_&]:min-h-svh";
export const SHELL_LAYOUT_FLAT =
  "[[data-page-shell]_&]:gap-0 [[data-page-shell]_&]:bg-transparent [[data-page-shell]_&]:p-0";
// For page-level chrome the shell's sidebar already provides.
export const SHELL_HIDDEN = "[[data-page-shell]_&]:hidden";
export const SHELL_RAIL_FLAT =
  "[[data-page-shell]_&]:rounded-none [[data-page-shell]_&]:border-y-0";
export const SHELL_RAIL_LEFT =
  "[[data-page-shell]_&]:border-l-0 [[data-page-shell]_&]:border-r-surface-quatenary";
export const SHELL_RAIL_RIGHT =
  "[[data-page-shell]_&]:border-r-0 [[data-page-shell]_&]:border-l-surface-quatenary";
